import React, { useEffect, useRef } from "react"
import { formatDateTo12HourTime } from 'utils/timeFormatters'
import { Box } from "../shared/box"
import Flex from "../shared/flex"
import { Text } from "../shared/text"
import { AnnotisedMessage } from "./chat-message"
import { CircleDivider, SenderName, TextMessage } from './styles'

const RecordedChatMessageItem = ({ index, message, style, setRowHeight }) => {
  let messageToRender = message.message
  const cleanedName = message.senderName.replace(/[^a-zA-Z0-9\s]/g, "")
  if (message.message?.includes("PROMO:")) {
    messageToRender = "Check our promotion for this class!"
  }

  const rowRef = useRef(null)

  useEffect(() => {
    if (rowRef.current) {
      setRowHeight(index, rowRef.current.clientHeight)
    }
  }, [index, setRowHeight])

  return (
    <Box as="div" css={{ overflow: "hidden" }} style={style}>
      <Flex
        gap=".5"
        align="center"
        css={{
          flexWrap: "wrap",
          userSelect: "none",
        }}
        key={message.time}
        data-testid="chat_msg"
        ref={rowRef}
      >
        <Flex
          gap="0"
          css={{
            color: "rgba(0,0,0, 0.82)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            fontSize: "1.6rem",
            height: "2rem",
          }}
          as="div"
        >
          <Flex align="center" gap="0">
            {!cleanedName ? (
              <SenderName>{cleanedName || "Anonymous"}</SenderName>
            ) : (
              <SenderName>{cleanedName}</SenderName>
            )}
            <CircleDivider />

            <Text
              css={{
                color: "rgba(0,0,0, 0.72)",
                flexShrink: 0,
                margin: 0,
                marginLeft: "0.6rem",
                fontSize: "1.4rem",
              }}
            >
              {formatDateTo12HourTime(message.time)}
            </Text>
          </Flex>
        </Flex>
        <TextMessage onClick={(e) => e.stopPropagation()}>
          <AnnotisedMessage message={messageToRender} />
        </TextMessage>
      </Flex>
    </Box>
  )
}

export default RecordedChatMessageItem